import { produce } from "immer";
import { OverlayAction, CLOSE_ALL_OVERLAYS, OPEN_MOBILE_MENU, OPEN_MEGA_DROPDOWN_MENU, OPEN_PRODUCTS_MENU, OPEN_COUNTRIES_MENU, OPEN_FACETS_MENU, OPEN_MEDIA_CLOUD_DOWNLOAD_OVERLAY, OPEN_MEDIA_CLOUD_EMAIL_OVERLAY } from "./overlay.actions";
import OverlayRootState from "../models/redux-state.interface";

const initialState: OverlayRootState = {
    currentOverlay: undefined,
    content: undefined
};

export default (overlayState = initialState, action: OverlayAction): OverlayRootState => produce(overlayState, draft => {
    switch (action.type) {
        case OPEN_MOBILE_MENU: {
            draft.currentOverlay = "MOBILE_MENU";
            draft.content = action.content;
            break;
        }
        case OPEN_FACETS_MENU: {
            draft.currentOverlay = "FACETS_MENU";
            draft.content = undefined;
            break;
        }
        case OPEN_MEGA_DROPDOWN_MENU: {
            draft.currentOverlay = "MEGA_DROPDOWN_MENU";
            draft.content = action.content;
            break;
        }
        case OPEN_PRODUCTS_MENU: {
            draft.currentOverlay = "PRODUCTS_MENU";
            draft.content = undefined;
            break;
        }
        case OPEN_COUNTRIES_MENU: {
            draft.currentOverlay = "COUNTRIES_MENU";
            draft.content = undefined;
            break;
        }
        case OPEN_MEDIA_CLOUD_DOWNLOAD_OVERLAY: {
            draft.currentOverlay = "MEDIA_CLOUD_DOWNLOAD_OVERLAY";
            draft.content = action.content;
            break;
        }
        case OPEN_MEDIA_CLOUD_EMAIL_OVERLAY: {
            draft.currentOverlay = "MEDIA_CLOUD_EMAIL_OVERLAY";
            draft.content = action.content;
            break;
        }
        case CLOSE_ALL_OVERLAYS: {
            draft.currentOverlay = undefined;
            draft.content = undefined;
            break;
        }
    }
});
